<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <el-button type="primary" icon="el-icon-plus" class="btn-add" @click="dialogFormVisible = true" v-if="permissionCodes.indexOf('015001001') !== -1">添加模板</el-button>
      <input-search :placeholder="searchPlaceholder" @search="search" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" :deleteTipInfo="deleteTipInfo" :operationArr="operationArr" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @previewRow="previewRow" @downloadRow="downloadRow" />

    <el-dialog title="新增合同模板" :visible.sync="dialogFormVisible">
      <el-tabs v-model="dialogTabsActiveName" type="card" style="margin-bottom: 20px;">
        <el-tab-pane label="基本信息" name="1">
          <div class="dialogTabsTitle" style="margin-top: 0">合同信息</div>
          <div class="dialogTabsMain">
            <el-button size="small" v-for="item in contractInformationList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>
          </div>
          <div class="dialogTabsTitle">房源信息</div>
          <div class="dialogTabsMain">
            <el-button size="small" v-for="item in housingInformationList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>
          </div>
          <div class="dialogTabsTitle">住户信息</div>
          <div class="dialogTabsMain">
            <el-button size="small" v-for="item in tenantInformationList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>
          </div>
          <!--<div class="dialogTabsTitle">滞纳金条款</div>-->
          <!--<div class="dialogTabsMain">-->
            <!--<el-button size="small" v-for="item in lateFeeClauseList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>-->
          <!--</div>-->
          <!--<div class="dialogTabsTitle">审核</div>-->
          <!--<div class="dialogTabsMain" style="margin-bottom: 20px;">-->
            <!--<el-button size="small" v-for="item in examineList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>-->
          <!--</div>-->
        </el-tab-pane>
        <el-tab-pane label="租赁费用条款" name="2">
          <div class="dialogTabsTitle">基本条款</div>
          <div class="dialogTabsMain">
            <el-button size="small" v-for="item in basicProvisionsList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>
          </div>
          <div class="dialogTabsTitle">保证金条款</div>
          <div class="dialogTabsMain">
            <el-button size="small" v-for="item in marginClauseList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>
          </div>
          <!--<div class="dialogTabsTitle">租期条款</div>-->
          <!--<div class="dialogTabsMain">-->
            <!--<el-button size="small" v-for="item in charterPeriodClauseList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>-->
          <!--</div>-->
          <!--<div class="dialogTabsTitle">递增率条款</div>-->
          <!--<div class="dialogTabsMain">-->
            <!--<el-button size="small" v-for="item in incrementalRateClauseList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>-->
          <!--</div>-->
          <!--<div class="dialogTabsTitle">优惠</div>-->
          <!--<div class="dialogTabsMain">-->
            <!--<el-button size="small" v-for="item in discountList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>-->
          <!--</div>-->
          <!--<div class="dialogTabsTitle">其他条款</div>-->
          <!--<div class="dialogTabsMain">-->
            <!--<el-button size="small" v-for="item in otherTermsList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>-->
          <!--</div>-->
          <div class="dialogTabsTitle">租金明细报表</div>
          <div class="dialogTabsMain">
            <el-button size="small" v-for="item in detailedStatementOfRentList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>
          </div>
          <div class="dialogTabsTitle">物业费明细报表</div>
          <div class="dialogTabsMain" style="margin-bottom: 20px;">
            <el-button size="small" v-for="item in propertyDetailedStatementOfRentList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>
          </div>
        </el-tab-pane>
        <!--<el-tab-pane label="物业费用条款" name="3">-->
          <!--<div class="dialogTabsTitle">基本条款</div>-->
          <!--<div class="dialogTabsMain">-->
            <!--<el-button size="small" v-for="item in propertyBasicProvisionsList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>-->
          <!--</div>-->
          <!--<div class="dialogTabsTitle">保证金条款</div>-->
          <!--<div class="dialogTabsMain">-->
            <!--<el-button size="small" v-for="item in propertyMarginClauseList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>-->
          <!--</div>-->
          <!--<div class="dialogTabsTitle">租期条款</div>-->
          <!--<div class="dialogTabsMain">-->
            <!--<el-button size="small" v-for="item in propertyCharterPeriodClauseList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>-->
          <!--</div>-->
          <!--<div class="dialogTabsTitle">递增率条款</div>-->
          <!--<div class="dialogTabsMain">-->
            <!--<el-button size="small" v-for="item in propertyIncrementalRateClauseList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>-->
          <!--</div>-->
          <!--<div class="dialogTabsTitle">优惠</div>-->
          <!--<div class="dialogTabsMain">-->
            <!--<el-button size="small" v-for="item in propertyDiscountList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>-->
          <!--</div>-->
          <!--<div class="dialogTabsTitle">物业费明细报表</div>-->
          <!--<div class="dialogTabsMain" style="margin-bottom: 20px;">-->
            <!--<el-button size="small" v-for="item in propertyDetailedStatementOfRentList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>-->
          <!--</div>-->
        <!--</el-tab-pane>-->
        <!--<el-tab-pane label="通知单条款" name="4">-->
          <!--<div class="dialogTabsTitle">通知单条款</div>-->
          <!--<div class="dialogTabsMain">-->
            <!--<el-button size="small" v-for="item in noticeList" :key="item" class="copyButton" :data-clipboard-text="item" @click="copy">{{item}}</el-button>-->
          <!--</div>-->
        <!--</el-tab-pane>-->
        <el-tab-pane label="上传合同模板" name="5">
          <div style="width: 360px;margin: 10px auto;">
            <div style="display: flex;justify-content: flex-start;">
              <div style="line-height: 30px;margin-right: 10px;vertical-align: middle;">
                <span style="color: #FF0000">*</span>
                <span>合同模板名称</span>
              </div>
              <el-input v-model="uploadData.contractTemplateName" size="small" placeholder="请输入合同模板名称" style="width: 220px;" />
            </div>
            <el-upload
              class="upload-demo"
              drag
              ref="uploadContract"
              :action="uploadAction"
              :auto-upload="false"
              :headers="uploadHeaders"
              :data="uploadData"
              :before-upload="beforeUploadContract"
              :on-success="uploadContractSuccess"
              :on-error="uploadContractError"
              :limit="1">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文档拖拽至虚线框内或<em>点击上传</em></div>
              <div class="el-upload__text">文档只支持doc, docx格式</div>
            </el-upload>
            <div style="margin-top: 20px;">
              <el-button type="primary" icon="el-icon-plus" class="btn-add" @click="uploadContractTemplate">保存模板</el-button>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import InputSearch from '../../../components/Input/InputSearch'
import TableMain from '../../../components/Table/TableMain'
import {api} from '../../api/SetFocus'
import {errorHandler} from '../../../utils/errorHandler'
import {nError, nSuccess} from '../../../utils/notice'
import {bus} from '../../../utils/bus'
import Clipboard from 'clipboard'

export default {
  components: {
    TableMain,
    InputSearch,
    Breadcrumb},
  name: 'contract-template',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [{
        value: '智慧文书',
        name: 'contract-template'
      }, {
        value: '合同模板'
      }],
      addBtnValue: '新建账户',
      searchPlaceholder: '合同模板名称',
      searchKey: '',
      deleteTipInfo: '是否确认删除该模板？',
      tableHead: [{
        prop: 'contractTemplateName',
        label: '合同模板名称'
      }, {
        prop: 'createTime',
        label: '创建时间'
      }],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      operationArr: ['preview', 'download', 'delete'],
      dialogFormVisible: false,
      dialogTabsActiveName: '1',
      // 合同信息
      contractInformationList: ['${合同编号}',  '${合同起租日}', '${合同结束日}', '${合同签订日}', '${付款周期}', '${合同起租日（【】格式）}', '${租赁期年数}', '${租赁信息租赁保证金}', '${租金列表（非表格）}', '${第一计租赁年度租金为人民币}'],
      // 房源信息
      housingInformationList: ['${楼宇名称}'],
      // 住户信息
      tenantInformationList: ['${住户名称}', '${住户联系人电话}', '${租赁信息房源信息}', '${租赁信息面积}'],
      // 滞纳金条款
      lateFeeClauseList: ['${滞纳金比例}', '${滞纳金上限}'],
      // 审核
      examineList: ['${审核人1}', '${审核人1的审核结果}', '${审核人1的审核时间}', '${审核人1的审核备注}', '${审核人2}', '${审核人2的审核结果}', '${审核人2的审核时间}', '${审核人2的审核备注}'],
      // 基本条款
      basicProvisionsList: ['${租赁信息免租期（天数）}', '${租赁信息免租期}'],
      // 保证金条款
      marginClauseList: ['${租赁信息保证金金额}', '${租赁信息大写保证金金额}'],
      // 租期条款
      charterPeriodClauseList: ['${租赁信息租金单价}'],
      // 递增率条款
      incrementalRateClauseList: ['${租赁信息租金递增率}', '${租赁信息押金递增率}'],
      // 优惠
      discountList: ['${租赁信息免租期}', '${租赁信息免租期（天数）}', '${租赁信息折扣}', '${租赁信息折扣金额}'],
      // 其他条款
      otherTermsList: ['${租赁信息其他条款支付类型}'],
      // 租金明细报表
      detailedStatementOfRentList: ['${租赁信息首期租金金额}', '${租赁信息付款时间表（表格）}', '${租金单价递增率}'],
      // 物业费基本条款
      propertyBasicProvisionsList: ['${物业信息房源信息}', '${物业信息面积}'],
      // 物业费保证金条款
      propertyMarginClauseList: ['${物业信息保证金}', '${物业信息保证金金额}'],
      // 物业费租期条款
      propertyCharterPeriodClauseList: ['${物业信息租金单价}'],
      // 物业费递增率条款
      propertyIncrementalRateClauseList: ['${物业信息租金递增率}', '${物业信息押金递增率}'],
      // 物业费优惠
      propertyDiscountList: ['${物业信息免租期}', '${物业信息免租期（天数）}', '${物业信息折扣}', '${物业信息折扣金额}'],
      // 物业费其他条款
      propertyOtherTermsList: ['${物业信息其他条款单价}', '${物业信息其他条款支付类型}'],
      // 物业费明细报表
      propertyDetailedStatementOfRentList: ['${物业信息租金单价}', '${物业信息付款时间表（表格）}'],
      // 备注条款
      remarksClauseList: ['${备注条款}'],
      // 通知单条款
      noticeList: ['${客户名称}', '${费用总计}', '${计费周期}', '${费用类型}', '${缴费截止时间}', '${通知单生成时间}'],
      uploadData: {
        contractTemplateName: ''
      },
      uploadHeaders: {
        token: '',
        'yq-app-code': ''
      },
      uploadAction: api.uploadContractTemplate
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
    this.uploadHeaders.token = bus.global.token
    this.uploadHeaders['yq-app-code'] = bus.global.yqCode
    this.getPage()
  },
  activated() {
    this.getPage()
  },
  methods: {
    getPage () {
      this.$axios.post(api.getContractTemplatePage, {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        searchKey: this.searchKey
      })
        .then(res => {
          if (res.data.retCode === 1) {
            this.total = res.data.data.total
            let data = res.data.data.list
            data.map(v => {
              v.createTime = v.createTime.slice(0, 19)
            })
            this.tableData = data
          }
        })
        .catch(errorHandler('获取合同列表失败'))
    },
    changePagination (data) {
      this.pageNum = data[0]
      this.pageSize = data[1]
      this.getPage()
    },
    search (v) {
      this.pageNum = 1
      this.searchKey = v
      this.getPage()
    },
    // 修改
    goToModifyPage (code) {
      this.$router.push({
        path: `/account_modify/${code}`
      })
    },
    // 删除
    deleteLine (code) {
      this.$axios.post(api.deleteContractTemplateByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.getPage()
          }
        })
        .catch(errorHandler('删除合同失败'))
    },
    // 合同预览
    previewRow (code) {
      this.tableData.map(v => {
        if (v.code === code) {
          window.open('http://view.officeapps.live.com/op/view.aspx?src=' + v.path, '_blank')
        }
      })
    },
    // 合同下载
    downloadRow (code) {
      this.tableData.map(v => {
        if (v.code === code) {
          window.open(v.path, '_blank')
        }
      })
    },
    // 保存合同
    uploadContractTemplate () {
      this.$refs.uploadContract.submit()
    },
    beforeUploadContract () {
      if (!this.uploadData.contractTemplateName) {
        nError('请输入合同模板名称')
        return false
      }
    },
    // 上传成功
    uploadContractSuccess () {
      this.$refs.uploadContract.clearFiles()
      this.uploadData.contractTemplateName = ''
      this.dialogFormVisible = false
      this.dialogTabsActiveName = '1'
      this.getPage()
    },
    // 上传失败
    uploadContractError (err) {
      nError('上传失败')
    },
    download (data) {
      if (!data) {
        return
      }
      let url = window.URL.createObjectURL(new Blob([data]))
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', 'excel.xlsx')

      document.body.appendChild(link)
      link.click()
    },
    // 复制按钮内容
    copy() {
      let clipboard = new Clipboard('.copyButton')
      clipboard.on('success', e => {
        nSuccess('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        nError('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy()
      })
    }
  },
  watch: {
    dialogFormVisible(val) {
      if (this.dialogFormVisible === false) {
        this.$refs.uploadContract.clearFiles()
        this.uploadData.contractTemplateName = ''
      }
    }
  }
}
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-add {
    border: 0;
    color: #FFF;
    padding: 8px 16px;
    background-color: #00a0e6;
  }
  .btn-add:hover {
    color: #FFF;
    background-color: #06b3ff;
  }
  .dialogTabsTitle {
    text-align: left;
    font-size: 16px;
    margin-top: 10px;
    font-weight: 500;
    color: #333333;
  }
  .dialogTabsMain {
    text-align: left;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .copyButton {
    color: #999999;
    padding: 8px 16px;
    margin: 10px 10px 0 10px;
    background-color: #FFFFFF;
    border: 1px solid #cccccc;
  }
  .copyButton:hover {
    color: #00A0E6;
    border: 1px solid #00A0E6;
  }
  .upload-demo {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/view/Document/ContractTemplate/ContractTemplate.vue